import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { InlineOverlay, InlineOverlayHeader, InlineOverlayFooter, InlineOverlayBody, InlineOverlayCloseButton } from '@bibliocommons/base-inline-overlay';
import { PrimaryButton } from '@bibliocommons/base-buttons';
import { Checkmark } from '@bibliocommons/base-icons';
import BibBrief from '@bibliocommons/shared-bib-brief';
import { bibShape } from '@bibliocommons/bc-prop-types';
import { GenericForm } from '@bibliocommons/shared-messages';

import { SHELF_NAMES } from '../../../../../../constants/ShelfConstants';
import MessagingContainer from '../../../../../../containers/shared/Messaging/MessagingContainer';
import CancelHoldShelfPrompt from '../../cancel-hold-shelf-prompt';

import '../styles/BaseCancelHoldWorkflowView.scss';

export class BaseCancelHoldWorkflowView extends BcReactComponent {
  constructor(props) {
    super(props);
    this.state = {
      shelfState: {
        toAdd: false,
        name: SHELF_NAMES.FOR_LATER
      }
    };
    this.bindAll('handleShelfPromptChange', 'handleCancelHold');
  }

  handleShelfPromptChange(newShelfState) {
    this.setState({
      shelfState: {
        ...this.state.shelfState,
        ...newShelfState
      }
    });
  }

  handleCancelHold() {
    const { shelfState } = this.state;
    this.props.handleClose();
    this.props.handleCancelHold({ shelfState });
  }

  renderShelfPrompt() {
    if (this.props.showShelfPrompt && !this.props.done) {
      return (
        <CancelHoldShelfPrompt handleChange={this.handleShelfPromptChange} {...this.state.shelfState} />
      );
    }

    return null;
  }

  renderTitle() {
    const { holdIds } = this.props;

    if (holdIds.size === 1) {
      return (
        <span>
          <FormattedMessage id="cancel_confirmation_hold_title" />...
        </span>
      );
    }

    return <FormattedMessage id="cancel_confirmation_hold_batch_title" values={{ count: holdIds.size }} />;
  }

  renderBibInfo() {
    const { bibs, holdIds } = this.props;
    const bib = bibs.first();
    const showBrief = (holdIds.size === 1 && bib);

    return showBrief && (
      <BibBrief
        bib={bib}
        titleTag="h3"
        renderTitleAsLink={false}
        renderAuthorsAsLink={false} />
    );
  }

  renderFooter() {
    const { isLoading, done } = this.props;
    return (!done) && (
      <InlineOverlayFooter>
        <div className="col-xs-12">
          <PrimaryButton className="pull-right" isLoading={isLoading} handleClick={this.handleCancelHold} data-test-id="confirm-cancel-hold">
            <Checkmark color="#FFF" /> <FormattedMessage id="cancel_confirmation_hold_button_yes" />
          </PrimaryButton>
          <InlineOverlayCloseButton className="btn btn-link pull-right">
            <FormattedMessage id="button_nevermind_close" />
          </InlineOverlayCloseButton>
        </div>
      </InlineOverlayFooter>
    );
  }

  render() {
    const { handleClose, testId } = this.props;
    return (
      <InlineOverlay handleClose={handleClose} data-test-id={testId}>
        <InlineOverlayHeader>
          {this.renderTitle()}
        </InlineOverlayHeader>
        <InlineOverlayBody className="cp-base-cancel-hold-workflow-view">
          <MessagingContainer id={this.props.messagingId}>
            {messageOptions => <GenericForm {...messageOptions} duration={false} />}
          </MessagingContainer>
          {this.renderBibInfo()}
          <FormattedMessage id="your_position_will_be_lost" />
          {this.renderShelfPrompt()}
        </InlineOverlayBody>
        {this.renderFooter()}
      </InlineOverlay>
    );
  }
}

BaseCancelHoldWorkflowView.propTypes = {
  handleCancelHold: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  accountId: PropTypes.number.isRequired,
  holdIds: ImmutablePropTypes.listOf(PropTypes.string),
  isLoading: PropTypes.bool,
  done: PropTypes.bool,
  showShelfPrompt: PropTypes.bool,
  bibs: ImmutablePropTypes.listOf(bibShape).isRequired,
  testId: PropTypes.string,
  messagingId: PropTypes.string
};

BaseCancelHoldWorkflowView.defaultProps = {
  showShelfPrompt: true
};

export default BaseCancelHoldWorkflowView;



// WEBPACK FOOTER //
// ./app/components/shared/ItemTransactions/components/cancel-hold-workflow-view/components/BaseCancelHoldWorkflowView.jsx